import React, { useEffect, useState } from 'react'
import {
  InputGroup,
  Input,
  Grid,
  Row,
  Col,
  Panel,
  Table,
  SelectPicker,
  Form,
  IconButton,
  Icon,
  Button,
  Message,
} from 'rsuite'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import TooltipButton from '../../components/buttons/TooltipButton'
import { cloneDeep } from 'lodash'
import NumberFormat from 'react-number-format'
import { doneLoading, startLoading } from '../../utils/loading'
import {
  deleteProgressIndicator,
  saveSingegleProgressIndicator,
} from '../../redux/actions/projectProgress'
import ConfirmWidget from '../confirm/ConfirmWidget'
import CKEditorFrom from '../../components/forms/input/CKEditorFrom'
import notification from '../../utils/notification'
import {
  DELETE_ERR_MSG,
  DELETE_SUCCESS_MSG,
  SAVE_ERR_MSG,
  SAVE_SUCCESS_MSG,
} from '../../constants/msgText'
import pathname from '../../constants/pathname'

export default function ProgressIndicatorForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  getValues,
  clearErrors,
  projectId,
  progressId,
  setFormSchema,
  onSelectConnection = () => {},
  ...props
}) {
  // const [schema, setSchema] = useState(_schema)
  const [datalist, setDataList] = useState(cloneDeep(schema.values || []))
  const [isLoading, setIsLoading] = useState()
  const [deleteObj, setDeleteObj] = useState()
  const [isShowDeleteCF, setIsShowDeleteCF] = useState(false)
  const dataKey = 'datalist'
  const newRowPrefixKey = 'ADD_ID_'
  const { Column, HeaderCell, Cell } = Table

  useEffect(() => {
    if (schema) {
      setDataList(schema.values || [])
    }
  }, [schema])

  const handleCallSaveService = async (request, projectId, progressId) => {
    startLoading()
    setIsLoading(true)
    let indicator = null
    try {
      console.log('call saveSingegleProgressIndicator.')
      indicator = await saveSingegleProgressIndicator(projectId, progressId, request)

      notification.open('success', {
        title: SAVE_SUCCESS_MSG,
        duration: 10000,
      })
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title:
          e?.response?.data?.errors?.message || e?.response?.data?.errorMessage || SAVE_ERR_MSG,
        duration: 10000,
      })
    }
    setIsLoading(false)
    doneLoading()

    return indicator
  }

  const handleCallDeleteService = async (id) => {
    startLoading()
    setIsLoading(true)
    let isSuccess = false
    try {
      console.log('call deleteProgressIndicator.')
      isSuccess = await deleteProgressIndicator(id)
      notification.open('success', {
        title: DELETE_SUCCESS_MSG,
        duration: 10000,
      })
    } catch (e) {
      //โชว popup
      console.log('error', e)
      notification.open('error', {
        title:
          e?.response?.data?.errors?.message || e?.response?.data?.errorMessage || DELETE_ERR_MSG,
        duration: 10000,
      })
    }
    setIsLoading(false)
    doneLoading()
    setIsShowDeleteCF(false)
    setDeleteObj()
    return isSuccess
  }

  const isNewRow = (id) => {
    console.log(id)
    return id.startsWith(newRowPrefixKey)
  }

  const onAddNewRow = (rowData) => {
    let arr = [...datalist]
    for (let index = 0; index < arr.length; index++) {
      const element = arr[index]

      if (element.id == rowData._parent.id) {
        for (let childrenIndex = 0; childrenIndex < element.children.length; childrenIndex++) {
          const childrenElement = element.children[childrenIndex]
          if (childrenElement.id == rowData.id) {
            let date = new Date().getTime()
            let newId = `${newRowPrefixKey}${date}`
            console.log('create add id ', newId)
            let data = {
              id: newId,
              progressOutcomeId: childrenElement.id,
              indicatorName: '',
              indicatorType: 0,
              unit: '',
              result: '',
              enableDelete: true,
              enableSave: true,
              isDelete: false,
            }
            arr[index].children[childrenIndex].children.push(data)
            break
          }
        }
        break
      }
    }
    // console.log('errors ', errors)
    // console.log('after add ', arr)
    setDataList(arr)
    setValue(dataKey, arr)
  }

  const onChangeValue = (rowData, value, key) => {
    let arr = [...datalist]
    for (let labelIndex = 0; labelIndex < arr.length; labelIndex++) {
      const element = arr[labelIndex]

      if (element.id == rowData._parent._parent.id) {
        for (let childrenIndex = 0; childrenIndex < element.children.length; childrenIndex++) {
          const childrenElement = element.children[childrenIndex]

          if (childrenElement.id == rowData._parent.id) {
            for (
              let indicatorIndex = 0;
              indicatorIndex < childrenElement.children.length;
              indicatorIndex++
            ) {
              const indicatorElement = childrenElement.children[indicatorIndex]
              if (indicatorElement.id == rowData.id) {
                arr[labelIndex].children[childrenIndex].children[indicatorIndex][key] = value
                if (key == 'indicatorType') {
                  arr[labelIndex].children[childrenIndex].children[indicatorIndex]['result'] = ''
                  arr[labelIndex].children[childrenIndex].children[indicatorIndex]['unit'] = ''
                }

                setDataList(arr)
                setValue(dataKey, arr)
                break
              }
            }
            break
          }
        }
        break
      }
    }
  }

  const onDeleteRow = async (rowData) => {
    console.log(rowData)
    let arr = [...datalist]
    for (let labelIndex = 0; labelIndex < arr.length; labelIndex++) {
      const element = arr[labelIndex]

      if (element.id == rowData._parent._parent.id) {
        for (let childrenIndex = 0; childrenIndex < element.children.length; childrenIndex++) {
          const childrenElement = element.children[childrenIndex]

          if (childrenElement.id == rowData._parent.id) {
            for (
              let indicatorIndex = 0;
              indicatorIndex < childrenElement.children.length;
              indicatorIndex++
            ) {
              const indicatorElement = childrenElement.children[indicatorIndex]
              if (indicatorElement.id == rowData.id) {
                if (!isNewRow(rowData.id)) {
                  var result = await handleCallDeleteService(rowData.id)

                  if (result) {
                    arr[labelIndex].children[childrenIndex].children.splice(indicatorIndex, 1)
                  }
                } else {
                  arr[labelIndex].children[childrenIndex].children.splice(indicatorIndex, 1)
                }

                setDataList(arr)
                setValue(dataKey, arr)
                break
              }
            }
            break
          }
        }
        break
      }
    }

    schema.values = arr
    setFormSchema(schema)
  }

  const onSaveRow = async (rowData) => {
    let arr = [...datalist]

    for (let labelIndex = 0; labelIndex < arr.length; labelIndex++) {
      const element = arr[labelIndex]

      if (element.id == rowData._parent._parent.id) {
        for (let childrenIndex = 0; childrenIndex < element.children.length; childrenIndex++) {
          const childrenElement = element.children[childrenIndex]

          if (childrenElement.id == rowData._parent.id) {
            for (
              let indicatorIndex = 0;
              indicatorIndex < childrenElement.children.length;
              indicatorIndex++
            ) {
              const indicatorElement = childrenElement.children[indicatorIndex]
              if (indicatorElement.id == rowData.id) {
                let request = {
                  id: isNewRow(indicatorElement.id) ? '' : indicatorElement.id,
                  progressOutcomeId: indicatorElement.progressOutcomeId,
                  indicatorName: indicatorElement.indicatorName,
                  indicatorType: indicatorElement.indicatorType,
                  unit: indicatorElement.unit || null,
                  result: indicatorElement.result || null,
                }

                var respData = await handleCallSaveService(request, projectId, progressId)

                if (respData) {
                  console.log('respData.id : ', respData.id)
                  arr[labelIndex].children[childrenIndex].children[indicatorIndex].id = respData.id
                  arr[labelIndex].children[childrenIndex].children[
                    indicatorIndex
                  ].progressOutcomeId = respData.progressOutcomeId
                  arr[labelIndex].children[childrenIndex].children[indicatorIndex].indicatorName =
                    respData.indicatorName
                  arr[labelIndex].children[childrenIndex].children[indicatorIndex].indicatorType =
                    respData.indicatorType
                  arr[labelIndex].children[childrenIndex].children[indicatorIndex].unit =
                    respData.unit
                  arr[labelIndex].children[childrenIndex].children[indicatorIndex].result =
                    respData.result
                  arr[labelIndex].children[childrenIndex].children[indicatorIndex].enableDelete =
                    respData.enableDelete
                  arr[labelIndex].children[childrenIndex].children[indicatorIndex].enableSave =
                    respData.enableSave
                  arr[labelIndex].children[childrenIndex].children[indicatorIndex].isDelete =
                    respData.isDelete
                }

                break
              }
            }
            break
          }
        }
        break
      }
    }

    setDataList(arr)
    setValue(dataKey, arr)

    schema.values = arr
    setFormSchema(schema)
  }

  const quantitative = (rowData) => {
    return (
      <Controller
        key={`${schema.result.name}_${rowData.id}`}
        name={`${schema.result.name}_${rowData.id}`}
        control={control}
        //rules={isValidators(schema.result.validators)}
        defaultValue={rowData.result}
        render={(props) => {
          return (
            <NumberFormat
              className="rs-input"
              placeholder={schema.result.hint}
              thousandSeparator={true}
              value={props.value}
              onValueChange={(value) => {
                props.onChange(value.floatValue)
                onChangeValue(rowData, value.floatValue, 'result')
              }}
            />
          )
        }}
      />
    )
  }

  const unitInput = (rowData) => {
    return (
      <Input
        key={`${schema.unit.name}_${rowData.id}`}
        name={`${schema.unit.name}_${rowData.id}`}
        placeholder={schema.unit.hint}
        defaultValue={rowData.unit}
        //inputRef={register(isValidators(schema.unit.validators))}
        onChange={(value) => {
          onChangeValue(rowData, value, 'unit')
        }}
      />
    )
  }

  const expectedOutcomeColumn = (rowData) => {
    if (rowData.label) {
      return rowData.label
    } else if (rowData.expectedOutcome) {
      return rowData.expectedOutcome
    } else {
      return rowData.enableDelete ? (
        <div>
          {errors[`${schema.indicatorName.name}_${rowData.id}`] && (
            <Row style={{ marginBottom: 10 }}>
              <ErrorMessage error={errors[`${schema.indicatorName.name}_${rowData.id}`]} />
            </Row>
          )}
          <Input
            key={`${schema.indicatorName.name}_${rowData.id}`}
            name={`${schema.indicatorName.name}_${rowData.id}`}
            placeholder={schema.indicatorName.hint}
            defaultValue={rowData.indicatorName}
            //inputRef={register(isValidators(schema.indicatorName.validators))}
            rows={3}
            componentClass="textarea"
            onChange={(value) => {
              onChangeValue(rowData, value, 'indicatorName')
            }}
          />
        </div>
      ) : (
        rowData.indicatorName
      )
    }
  }

  const indicatorTypeColumn = (rowData) => {
    if (typeof rowData.indicatorType !== 'undefined' && rowData.enableDelete) {
      return (
        <SelectPicker
          data={schema.indicatorOptions}
          searchable={false}
          value={rowData.indicatorType}
          onChange={(value) => {
            onChangeValue(rowData, value, 'indicatorType')
          }}
        />
      )
    } else if (typeof rowData.indicatorType !== 'undefined') {
      return (
        <>
          {schema.indicatorOptions.map((item) => {
            if (item.value == rowData.indicatorType) {
              return item.label
            }
          })}
        </>
      )
    }
  }

  return (
    <div>
      <Row>
        <Panel bodyFill>
          <Grid fluid>
            <Controller
              key={dataKey}
              name={dataKey}
              control={control}
              defaultValue={datalist || []}
              render={(props) => {
                return (
                  // />
                  <Table
                    isTree
                    defaultExpandAllRows
                    rowKey="id"
                    cellBordered
                    // height={400}
                    autoHeight
                    wordWrap
                    data={datalist || []}
                  >
                    <Column resizable width={500}>
                      <HeaderCell>{schema.columnText1}</HeaderCell>
                      <Cell>
                        {(rowData) => {
                          return expectedOutcomeColumn(rowData)
                        }}
                      </Cell>
                    </Column>

                    <Column resizable width={180} align="center">
                      <HeaderCell>{schema.columnText2}</HeaderCell>
                      <Cell>
                        {(rowData) => {
                          return indicatorTypeColumn(rowData)
                        }}
                      </Cell>
                    </Column>

                    <Column minWidth={250} width={250} flexGrow={1}>
                      <HeaderCell>{schema.columnText3}</HeaderCell>
                      <Cell style={{ height: '100%' }}>
                        {(rowData) => {
                          return rowData.progressOutcomeId ? (
                            <>
                              {rowData.indicatorType == 1 ? (
                                <Row>
                                  <span>{rowData.indicatorResult}</span>

                                  {/* {rowData.enableDelete ? (
                                      <Row>
                                        <Col xs={24} sm={18} md={18}>
                                          {errors[`${schema.result.name}_${rowData.id}`] && (
                                            <Row style={{ marginBottom: 10 }}>
                                              <ErrorMessage
                                                error={errors[`${schema.result.name}_${rowData.id}`]}
                                              />
                                            </Row>
                                          )}
                                          {quantitative(rowData)}
                                        </Col>
                                        <Col xs={24} sm={6} md={6}>
                                          {errors[`${schema.unit.name}_${rowData.id}`] && (
                                            <Row style={{ marginBottom: 10 }}>
                                              <ErrorMessage
                                                error={errors[`${schema.unit.name}_${rowData.id}`]}
                                              />
                                            </Row>
                                          )}
                                          {unitInput(rowData)}
                                        </Col>
                                      </Row>
                                    ) : (
                                      <InputGroup>
                                        {errors[`${schema.result.name}_${rowData.id}`] && (
                                          <Row style={{ marginBottom: 10 }}>
                                            <ErrorMessage
                                              error={errors[`${schema.result.name}_${rowData.id}`]}
                                            />
                                          </Row>
                                        )}
                                        {quantitative(rowData)}
                                        <InputGroup.Addon>
                                          <p>{rowData.unit}</p>
                                        </InputGroup.Addon>
                                      </InputGroup>
                                    )} */}
                                </Row>
                              ) : (
                                <div style={{ minHeight: 240, minWidth: 250 }}>
                                  <Form>
                                    <CKEditorFrom
                                      name={`${schema.result.name}_${rowData.id}`}
                                      value={rowData.result}
                                      schema={schema.result}
                                      register={register}
                                      Controller={Controller}
                                      control={control}
                                      errors={errors}
                                      setValue={setValue}
                                      clearErrors={clearErrors}
                                      onChange={(value) => {
                                        onChangeValue(rowData, value, 'result')
                                      }}
                                      // toolbar={[['Maximize']]}
                                      toolbar={[[]]}
                                    />
                                  </Form>
                                </div>

                                // <Input
                                //   key={`${schema.result.name}_${rowData.id}`}
                                //   name={`${schema.result.name}_${rowData.id}`}
                                //   placeholder={schema.result.hint}
                                //   defaultValue={rowData.result}
                                //   //inputRef={register(isValidators(schema.result.validators))}
                                //   rows={3}
                                //   componentClass="textarea"
                                //   onChange={(value) => {
                                //     onChangeValue(rowData, value, 'result')
                                //   }}
                                // />
                              )}
                            </>
                          ) : (
                            rowData.result
                          )
                        }}
                      </Cell>
                    </Column>
                    <Column resizable width={200} align="center" fixed="right">
                      <HeaderCell></HeaderCell>
                      <Cell>
                        {(rowData) => {
                          if (rowData.addLevel) {
                            return (
                              <TooltipButton
                                style={{ width: '100%' }}
                                icon="plus"
                                tooltip={`เพิ่ม${schema.buttonText || ''}`}
                                onClick={() => onAddNewRow(rowData)}
                                disabled={isLoading}
                              >
                                เพิ่ม
                              </TooltipButton>
                            )
                          } else {
                            return (
                              <>
                                {rowData.enableSave &&
                                  (rowData.indicatorType != 1 ||
                                  rowData.id.indexOf(newRowPrefixKey) != -1 ? (
                                    <TooltipButton
                                      style={{ width: '100%' }}
                                      icon="save"
                                      tooltip={`บันทึก${schema.buttonText || ''}`}
                                      onClick={() => onSaveRow(rowData)}
                                      disabled={isLoading}
                                    >
                                      บันทึก
                                    </TooltipButton>
                                  ) : (
                                    <>
                                      <TooltipButton
                                        style={{ width: '100%' }}
                                        icon="edit"
                                        tooltip={`ระบุความเชื่อมโยงของยุทธศาสตร์การทำงาน`}
                                        onClick={() => {
                                          // setIsShowConnection(true)
                                          onSelectConnection(rowData)
                                        }}
                                        disabled={
                                          isLoading || rowData.id.indexOf(newRowPrefixKey) != -1
                                        }
                                      >
                                        ความเชื่อมโยง
                                      </TooltipButton>

                                      {/* <Message
                                        showIcon
                                        style={{ marginTop: 10 }}
                                        type="warning"
                                        description={
                                          <p>
                                            <a
                                              href="#"
                                              onClick={() => {
                                                window.location.href = `${pathname.proposal.projectManagement.intellectualProperty}`
                                                window.opener = null
                                              }}
                                            >
                                              กรุณากรอกรายละเอียดงานวิจัยและนวัตกรรมให้ครบถ้วน
                                            </a>
                                          </p>
                                        }
                                      /> */}

                                      {rowData.enableDelete && (
                                        <TooltipButton
                                          style={{ width: '100%', marginTop: 10 }}
                                          icon="save"
                                          tooltip={`บันทึก${schema.buttonText || ''}`}
                                          onClick={() => onSaveRow(rowData)}
                                          disabled={isLoading}
                                        >
                                          บันทึก
                                        </TooltipButton>
                                      )}
                                    </>
                                  ))}

                                {rowData.enableDelete && (
                                  <TooltipButton
                                    style={{ width: '100%', marginTop: 10 }}
                                    icon="trash"
                                    tooltip={`ลบ${schema.buttonText || ''}`}
                                    onClick={() => {
                                      if (isNewRow(rowData.id)) {
                                        onDeleteRow(rowData)
                                      } else {
                                        setDeleteObj(rowData)
                                        setIsShowDeleteCF(true)
                                      }
                                    }}
                                    disabled={isLoading}
                                    // buttonClass="bt-gost-icon-radius-cancel"
                                    // iconClass="bt-gost-icon-radius-cancel"
                                  >
                                    ลบ
                                  </TooltipButton>
                                )}
                              </>
                            )
                          }
                        }}
                      </Cell>
                    </Column>
                  </Table>
                )
              }}
            />
          </Grid>
        </Panel>

        <ConfirmWidget
          title={`ยืนยันการลบ`}
          show={isShowDeleteCF}
          size="sm"
          detail={
            <>
              {`ยืนยันการลบผลลัพธ์ ตัวชีวัด : `}
              <b>{deleteObj?.indicatorName || ''}</b>
            </>
          }
          onCancle={() => {
            setIsShowDeleteCF(false)
            setDeleteObj()
          }}
          onConfirm={() => onDeleteRow(deleteObj)}
        />
      </Row>
    </div>
  )
}
